<template>
  <p class="losenge">
    <translate v-if="contactStore.isCustomerTypeCustomer"
      >I am a customer of Pitchup.com</translate
    >
    <translate v-if="contactStore.isCustomerTypeSiteOwner"
      >I am a site owner</translate
    >
    <translate v-if="contactStore.isCustomerTypeOther"
      >I am neither a customer nor a site owner</translate
    >
    <a @click="onChangeCustomerTypeLinkClick">
      <translate>Change</translate>
    </a>
  </p>
</template>

<script setup lang="ts">
const contactStore = useContactStoreSetup(usePinia())
const router = useRouter()

async function onChangeCustomerTypeLinkClick() {
  contactStore.updateReason('')
  await router.push({ params: { customerType: '' } })
}
</script>
<style scoped>
p {
  font-weight: bold;
  font-style: italic;
}

a {
  color: var(--colour-text-light);
  font-weight: normal;
  font-style: normal;
}
</style>
